import React from 'react';



export const Footer=()=>{
    return(
        <div className='footer'>
            <div className='__container'>
                <div className='footer_row'>
                    <p>privacy</p>
                    <p>ujjo llc, columbus oh, 43219</p>
                    <p>instagram</p>
                </div>
            </div>
        </div>
    )
}